<ng-container *ngIf="!!tab">
    <div *ngIf="!requestDonation && !!order && (!displayTipSelection || tab.tipAgainstAmount === 0); else displaySummary"
         class="itemized-order-container"
         [class.order-container-tip]="displayTipSelection">
        <bb-display-order
                [order]="order"
                [allowGrid]="true"
                [editable]="editable"
                [availableOrderComps]="availableOrderComps"
                [showImageOverride]="true"
                (addCredit)="addCredit.emit($event)"
                (removeCredit)="removeCredit.emit($event)"
                (removeTokens)="removeTokens.emit($event)"
                (addTokens)="addTokens.emit($event)"
                (openItemSummary)="openEditOrderItemSummary($event)"
                (removeItemSummary)="removeItemSummary($event)"
                (addToSummary)="addItem($event)"
                (removeFromSummary)="removeItem($event)">
        </bb-display-order>
    </div>

    <ng-template #displaySummary>
        <div *ngIf="!requestDonation" class="order-container"
             [class.org-logo-only]="!organization.showItemizedOrderOnCloseout"
             [class.order-container-tip]="displayTipSelection"
             [class.order-container-close-tab]="paymentMethod === 'CLOSE_TAB' || paymentMethod === 'GIFT_CARD'">

            <img *ngIf="!!organization.logoAddress"
                 [class.org-logo-only-image]="!organization.showItemizedOrderOnCloseout"
                 [src]="organizationLogoSrc" class="org-logo" alt="">

            <div *ngIf="organization.showItemizedOrderOnCloseout && !requestDonation" class="order-summary">
                <bb-display-order [order]="order"
                                  [allowGrid]="false"
                                  [details]="true"
                                  [editable]="false"
                                  [largeFont]="true"
                                  [showImageOverride]="false">
                </bb-display-order>
            </div>
        </div>
    </ng-template>
    <div class="donation-container"
         [class.donation-container-close-tab]="paymentMethod === 'CLOSE_TAB'"
         *ngIf="requestDonation && !!pickupLocation.activeDonationProgram && displayTipSelection">
        <ion-grid class="donation-block">
            <ion-row>
                <ion-col size-xs="12" size-lg="4" class="donation-image ion-justify-content-center">
                    <img *ngIf="pickupLocation.activeDonationProgram.imageAddress"
                         [src]="donationImageSrc"
                         alt="">
                </ion-col>
                <ion-col size-xs="12" size-lg="8">
                    <h1>Would you like to donate to {{ pickupLocation.activeDonationProgram.name }}?</h1>
                    <bb-donation [maxDonation]="maxDonation"
                                 [tabTotal]="total()"
                                 [donation]="!!donationItem ? donationItem.total : null"
                                 [donationProgram]="pickupLocation.activeDonationProgram"
                                 (donationChange)="handleDonation($event)">
                    </bb-donation>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size-xs="12">
                    <ion-item class="total" lines="none">
                        <ion-grid class="payment-information">
                            <ion-row>
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Subtotal:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tab.subtotal | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab.paymentInformation && !!tab.paymentInformation.credits">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Comps:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tab.paymentInformation.credits | currency }}</ion-col>
                            </ion-row>

                            <ion-row class="donation"
                                     (click)="returnToTip.emit()">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Tip:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tip | currency }}</ion-col>
                            </ion-row>

                            <ion-row>
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Donation:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ donation | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab && !!tab.paymentInformation && !!tab.paymentInformation.mobileFees">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Convenience Fee:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tab.paymentInformation.mobileFees | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab && !!addedTaxes">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Taxes:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ addedTaxes | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!splitAmount">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Split:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ splitAmount | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab && !!surcharge && !splitAmount">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Surcharges:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ surcharge | currency }}</ion-col>
                            </ion-row>

                            <ion-row>
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Total:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ totalPayment | currency }}</ion-col>
                            </ion-row>

                            <ng-container *ngIf="tab.paymentInformation.depositsRemaining">
                                <ion-row>
                                    <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                        <ion-text color="tertiary">
                                            Deposits:
                                        </ion-text>
                                    </ion-col>
                                    <ion-col class="ion-text-end">
                                        <ion-text color="tertiary">{{ tab.paymentInformation.depositsRemaining | currency }}</ion-text>
                                    </ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                        Total Due:
                                    </ion-col>
                                    <ion-col class="ion-text-end">{{ totalDue() | currency }}</ion-col>
                                </ion-row>
                            </ng-container>
                        </ion-grid>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
    <div class="tip tip-with-itemized-items"
         *ngIf="!requestDonation && displayTipSelection && organization.allowTips && !!tab && maxTip != 0 && tipAgainstAmount > 0 && !!paymentMethod">
        <ion-grid *ngIf="paymentMethod === 'CHARGE' || paymentMethod === 'CLOSE_TAB' || paymentMethod === 'GIFT_CARD'"
                  class="tip-container">
            <ng-container *ngIf="!displayChargeAuth">
                <ion-row *ngIf="!!tab.person">
                    <ion-col class="ion-text-center">
                        <div class="thank-you-container">
                        <span class="thank-you-text">
                        Thank you{{
                                !!tab && !!tab.person && !!tab.person.name && !!tab.person.name.trim() && tab.person.name !== 'Unsaved Claim' && tab.person.name !== 'Single Pay' && tab.person.name !== 'Tab Customer'
                                    ? ' ' + tab.person.name
                                    : ''
                            }}!</span>
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="terminal">
                    <ion-col size-xs="12" class="ion-text-end ion-padding-end">
                        <h1 *ngIf="paymentMethod === 'CLOSE_TAB'">Select a tip option.</h1>
                        <h1 *ngIf="paymentMethod !== 'CLOSE_TAB'">
                            Select a tip option to activate {{ manualCardEntry ? 'card entry' : 'the card reader' }}.
                        </h1>
                    </ion-col>
                </ion-row>
            </ng-container>
            <ng-container *ngIf="!displayChargeAuth || displayChargeAuthTip">
                <ion-row>
                    <ion-col size-xs="12">
                        <bb-tip [max]="maxTip"
                                [hideTip]="true"
                                [tabTotal]="tipAgainstAmount"
                                (tipChange)="tipChanged($event)">
                        </bb-tip>
                    </ion-col>
                </ion-row>
            </ng-container>
            <ion-row>
                <ion-col size-xs="12">
                    <ion-item class="total" lines="none">
                        <ion-grid class="payment-information">
                            <ion-row>
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Subtotal:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tab.subtotal | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab.paymentInformation.tokenPaymentsTotal">
                                <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                                    Tokens Value:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tab.paymentInformation.tokenPaymentsTotal | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab.paymentInformation && !!tab.paymentInformation.credits">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Comps:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tab.paymentInformation.credits | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab && !!tab.paymentInformation && !!tab.paymentInformation.mobileFees">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Convenience Fee:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tab.paymentInformation.mobileFees | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab && !!addedTaxes">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Taxes:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ addedTaxes | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!splitAmount">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Split:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ splitAmount | currency }}</ion-col>
                            </ion-row>

                            <ion-row *ngIf="!!tab && !!surcharge">
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Surcharges:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ surcharge | currency }}</ion-col>
                            </ion-row>

                            <ion-row>
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Tip:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ tip | currency }}</ion-col>
                            </ion-row>

                            <ion-row>
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Total:
                                </ion-col>
                                <ion-col class="ion-text-end">{{ totalPayment | currency }}</ion-col>
                            </ion-row>

                            <ng-container *ngIf="tab.paymentInformation.depositsRemaining">
                                <ion-row>
                                    <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                        <ion-text color="tertiary">
                                            Deposits:
                                        </ion-text>
                                    </ion-col>
                                    <ion-col class="ion-text-end">
                                        <ion-text color="tertiary">{{ tab.paymentInformation.depositsRemaining | currency }}</ion-text>
                                    </ion-col>
                                </ion-row>

                                <ion-row>
                                    <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                        Total Due:
                                    </ion-col>
                                    <ion-col class="ion-text-end">{{ totalDue() | currency }}</ion-col>
                                </ion-row>
                            </ng-container>
                        </ion-grid>
                    </ion-item>

                    <ion-item *ngIf="!!applyingGiftCard" class="total" lines="none">
                        <ion-grid>
                            <ion-row>
                                <ion-col size-xs="5" size-sm="8" size-md="9" class="ion-text-end">
                                    Gift Card Balance:
                                    <p class="sub-header">After Payment</p>
                                </ion-col>
                                <ion-col class="ion-text-end">{{ subtractCurrency(applyingGiftCard.balance, totalWithDonation()) | currency }}
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-item>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>

    <ng-container *ngIf="!displayTipSelection || tab.tipAgainstAmount === 0">
        <ion-item lines="none"
                  class="subtotal">
            <ion-grid>
                <ion-row>
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Subtotal:
                    </ion-col>
                    <ion-col class="ion-text-end">{{ tab.subtotal | currency }}</ion-col>
                </ion-row>
                <ion-row *ngIf="!!tab.paymentInformation.tokenPaymentsTotal">
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Tokens Used:
                    </ion-col>
                    <ion-col class="ion-text-end">
                        <bb-tokens [count]="tab.paymentInformation.tokensUsed"></bb-tokens>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="!!tab.paymentInformation.tokenPaymentsTotal">
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Tokens Value:
                    </ion-col>
                    <ion-col class="ion-text-end">{{ tab.paymentInformation.tokenPaymentsTotal | currency }}</ion-col>
                </ion-row>
                <ion-row *ngIf="tab.paymentInformation.payments > 0 && tab.paymentInformation.remaining > 0">
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Due:
                    </ion-col>
                    <ion-col class="ion-text-end">{{ tab.paymentInformation.remaining | currency }}</ion-col>
                </ion-row>
                <ion-row *ngIf="!!tab.credits && tab.credits.length > 0">
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Tab Comps:
                    </ion-col>
                </ion-row>

                <ion-row *ngFor="let credit of tab.credits">
                    <ion-col size-xs="12" class="ion-text-end">
                        <div class="comp-container">
                            <div class="comp-label ion-text-end">
                            <span *ngIf="!!credit.compDefinition">{{ credit.compDefinition.name }} <span
                                    *ngIf="credit.compDefinition.type === compDefinitionTypes.PERCENT">
                                ({{ credit.compDefinition.amount }}%)</span></span>
                                <p>({{ credit.amount | currency }})</p>
                            </div>
                            <div *ngIf="editable" class="comp-actions">
                                <ion-toolbar>
                                    <ion-buttons>
                                        <ion-button color="dark" (click)="deleteCredit.emit(credit)">
                                            <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                                        </ion-button>
                                    </ion-buttons>
                                </ion-toolbar>
                            </div>
                        </div>
                    </ion-col>
                </ion-row>
                <ng-container *ngIf="!!taxes || surcharge > 0">
                    <ion-row *ngIf="tab.paymentInformation.orderItemCredits > 0">
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            Item Credits Total:
                        </ion-col>
                        <ion-col class="ion-text-end">
                            <ion-text color="success">({{ tab.paymentInformation.orderItemCredits | currency }})</ion-text>
                        </ion-col>
                    </ion-row>
                    <ng-container *ngIf="!tab.taxExemptionId && !editTaxExemption && !!taxes">
                        <ion-row *ngFor="let tax of taxes">
                            <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                                {{ tax.name }} ({{ tax.taxRate }}%):
                            </ion-col>
                            <ion-col class="ion-text-end tax-container">
                                <span class="tax-name">{{ tax.tax | currency }}</span>
                                <ng-container *bbSecured="featureKeys.TAX_EXEMPT_APPLY">
                                    <ion-icon *ngIf="managerApp && !paymentMethod && organization.allowTaxExempt"
                                              name="close-circle-outline"
                                              class="tax-exempt"
                                              (click)="openEditTaxExemption()"></ion-icon>
                                </ng-container>
                            </ion-col>
                        </ion-row>
                    </ng-container>
                    <ion-row *ngIf="editTaxExemption">
                        <ion-col offset-sm="8" offset-md="9" class="ion-text-end">
                            <bb-edit-tax-exemption [tab]="tab" (close)="closeEditTaxExemption($event)"></bb-edit-tax-exemption>
                        </ion-col>
                    </ion-row>

                    <ion-row *ngIf="!!tab.taxExemptionId && !editTaxExemption">
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            Tax Exemption ID:
                        </ion-col>
                        <ion-col class="ion-text-end">
                            <bb-secured feature="{{featureKeys.TAX_EXEMPT_APPLY}}">
                                <a (click)="openEditTaxExemption()">{{ tab.taxExemptionId }}</a>
                                <span notAuthorized>Tax Exempt</span>
                            </bb-secured>
                        </ion-col>
                    </ion-row>

                    <ion-row *ngIf="tab.membershipFee">
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            {{ organization.membershipLabel }} Renewal Fees:
                        </ion-col>
                        <ion-col class="ion-text-end">{{ tab.membershipFee | currency }}</ion-col>
                    </ion-row>

                    <ion-row *ngIf="tab.mobileFee">
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            Mobile Order Fee:
                        </ion-col>
                        <ion-col class="ion-text-end">{{ tab.mobileFee | currency }}</ion-col>
                    </ion-row>

                    <ion-row *ngIf="surcharge > 0">
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            Surcharge:
                        </ion-col>
                        <ion-col class="ion-text-end">{{ surcharge | currency }}</ion-col>
                    </ion-row>

                    <ng-container *ngIf="tipPoolItems && tipPoolItems.length > 0">
                        <ion-row *ngFor="let item of tipPoolItems; trackBy: getId">
                            <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                                {{ item.menuItem.name }}:
                            </ion-col>
                            <ion-col class="ion-text-end">{{ item.calcTotal() | currency }}</ion-col>
                        </ion-row>
                    </ng-container>

                    <ng-container *ngIf="tipPoolSelectionItems && tipPoolSelectionItems.length > 0">
                        <ion-row *ngFor="let selectionItem of tipPoolSelectionItems; trackBy: getId">
                            <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                                {{ selectionItem.orderItem.menuItem.name }}:
                            </ion-col>
                            <ion-col class="ion-text-end">{{ selectionItem.orderItem.total | currency }}</ion-col>
                        </ion-row>
                    </ng-container>
                </ng-container>

                <ng-container *ngIf="editable">
                    <ion-row *ngIf="!!tab.giftCardPayments && tab.giftCardPayments.length > 0">
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            Gift Cards:
                        </ion-col>
                    </ion-row>

                    <ion-row *ngFor="let payment of tab.giftCardPayments">
                        <ion-col size-xs="12" class="ion-text-end">
                            <span class="gift-card-number">************{{ payment.cardLastFour }}</span>
                            <span class="gift-card-balance">{{ payment.amount | currency }}</span>

                            <ion-buttons slot="end">
                                <ion-button color="dark" (click)="deleteGiftCardPayment.emit(payment)">
                                    <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                                </ion-button>
                            </ion-buttons>
                        </ion-col>
                    </ion-row>
                </ng-container>
            </ion-grid>
        </ion-item>

        <ion-item class="total" lines="none">
            <ion-grid>
                <ion-row *ngIf="!!tip">
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Tip:
                    </ion-col>
                    <ion-col class="ion-text-end">{{ tip | currency }}</ion-col>
                </ion-row>

                <ion-row class="total">
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Total:
                    </ion-col>
                    <ion-col class="ion-text-end">{{ total() | currency }}</ion-col>
                </ion-row>

                <ng-container *ngIf="tab.paymentInformation.depositsRemaining">
                    <ion-row>
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            <ion-text color="tertiary">
                                Deposits:
                            </ion-text>
                        </ion-col>
                        <ion-col class="ion-text-end">
                            <ion-text color="tertiary">{{ tab.paymentInformation.depositsRemaining | currency }}</ion-text>
                        </ion-col>
                    </ion-row>

                    <ion-row>
                        <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                            Total Due:
                        </ion-col>
                        <ion-col class="ion-text-end">{{ totalDue() | currency }}</ion-col>
                    </ion-row>
                </ng-container>

                <ion-row *ngIf="!!applyingGiftCard">
                    <ion-col size-xs="8" size-sm="8" size-md="9" class="ion-text-end">
                        Gift Card Balance:
                        <p class="sub-header">After Payment</p>
                    </ion-col>
                    <ion-col class="ion-text-end">{{ subtractCurrency(applyingGiftCard.balance, totalWithDonation()) | currency }}</ion-col>
                </ion-row>
            </ion-grid>
        </ion-item>
    </ng-container>
</ng-container>
